import { Injectable } from '@angular/core';
import {MenuType} from '../services/modules.service';
import { I18nService } from './i18n.service';

export interface MenuButton {
  icon: string;
  text: string;
  action: () => void;
  tooltip: string;
  isActive?: boolean; // 添加這個可選屬性
  componentKey?: string; // 添加元件識別鍵，用於 URL 載入時的狀態同步
}

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(private i18nService: I18nService) {}


  getSideMenuIcons(
    companyCode: string,
    vectorStoreId: string,
    callbacks: {
      gotolobby: () => void;
      toggleVisibility: () => void;
      adjustFontSize: (direction: 'increase' | 'decrease') => void;
      clearmsg: () => void;
      gotoformlist:()=> void;
      gotoRAGDatabase:()=> void;
      gotoChat:()=> void;
      gotoToDolist:()=> void;
      gotoReportCenter:()=> void;
    }
  ): MenuButton[] {

    const buttons: MenuButton[] = [
      {
        icon: 'fa-regular fa-circle-left',
        text: '',
        action: callbacks.gotolobby,
        tooltip: 'Home',
      },
      {
        icon: 'fa-solid fa-circle-info',
        text: '',
        action: callbacks.toggleVisibility,
        tooltip: 'Show Instruction',
      }
    ];

    if (companyCode === 'Tpic') {
      buttons.push(
        {
          icon: 'fa-solid fa-magnifying-glass-plus',
          text: '',
          action: () => callbacks.adjustFontSize('increase'),
          tooltip: '放大字體',
        },
        {
          icon: 'fa-solid fa-magnifying-glass-minus',
          text: '',
          action: () => callbacks.adjustFontSize('decrease'),
          tooltip: '縮小字體',
        }
      );
    }

    if (companyCode === 'Quallico' || companyCode === 'JSAI' || companyCode === 'YH') {
      if (vectorStoreId) {
        buttons.push({
          icon: 'fa-solid fa-database',
          text: '',
          action: callbacks.gotoRAGDatabase,
          tooltip: 'Files Center',
        });
      }
    }


    buttons.push({
      icon: 'fa-solid fa-trash',
      text: '',
      action: callbacks.clearmsg,
      tooltip: 'clear message',
    });

    return buttons;
  }


  generateMenuButtons(
    menuItems: MenuType[],
    callbacks: {
      gotolobby: () => void; // Add this new callback
      clearmsg: () => void;
      go_to_component: (componentName: string, jsonData?: any) => void;
      go_to_assistant: (assistantItem: MenuType) => void; // 修改這裡的參數類型，從 string 改為 MenuType
    },
    userroleid: string[] = []
  ): MenuButton[] {
    if (!menuItems || menuItems.length === 0) {
      return [];
    }

    const buttons: MenuButton[] = [
      {
        icon: 'fa-regular fa-circle-left',
        text: this.i18nService.translate('menu.back_to_lobby'),
        action: callbacks.gotolobby,
        tooltip: 'Home',
      },
      // {
      //   icon: 'fa-solid fa-trash',
      //   text: '清除對話',
      //   action: callbacks.clearmsg,
      //   tooltip: 'clear message',
      // }
    ];

    console.log('userroleid:', userroleid);
    console.log('menuItems:', menuItems);



    const visibleMenuItems = menuItems.filter(item => {
      // 如果項目被標記為隱藏，過濾掉
      if (item.hide) {
        return false;
      }

      // 如果沒有 permission 屬性或為空陣列，表示該項目對所有人可見
      if (!item.permission || !Array.isArray(item.permission) || item.permission.length === 0) {
        return true;
      }

      // 如果使用者角色 ID 為空，且項目有權限設定，則無權限存取
      if (!userroleid || userroleid.length === 0) {
        return false;
      }

      // 檢查使用者是否具有存取該項目的權限
      const hasAccess = item.permission.some(permission => {
        // 檢查 permission 物件是否有效
        if (!permission || typeof permission.roleid !== 'string') {
          return false;
        }

        // 檢查 roleid 是否包含在 userroleid 中
        const hasRole = userroleid.includes(permission.roleid);

        // 檢查 permissionlist 中是否有 "Access" 權限
        const hasAccessPermission = permission.permissionlist &&
                                  Array.isArray(permission.permissionlist) &&
                                  permission.permissionlist.includes('Access');

        return hasRole && hasAccessPermission;
      });

      return hasAccess;
    });

    const menuButtons =  visibleMenuItems.map(item => {
      // 設置默認圖示和提示
      // const defaultIcon = item.type === 'page' ? 'fa-solid fa-file-alt' : 'fa-solid fa-robot';
      // const defaultTooltip = item.type === 'page' ? '開啟頁面' : '與助理對話';

      let buttonAction: () => void;

      // 根據類型設置按鈕的操作
      if (item.type === 'page') {
        buttonAction = () => callbacks.go_to_component(
          item.component_name || '',
          item.jsondata || {}
        );
      } else {
        // type === 'assistant'
        // 傳遞整個 item 對象而不只是 assistantId
        buttonAction = () => callbacks.go_to_assistant(item);
      }

      // 生成並返回按鈕
      return {
        icon: item.icon,
        text: item.text || '',
        action: buttonAction,
        tooltip: item.tooltip,
        componentKey: item.type === 'page' ? item.component_name : undefined // 為 page 類型的選單添加 componentKey
      };

    });

    return [...buttons, ...menuButtons];
  }




}
